import { Outlet } from 'react-router-dom'

import { config } from '@/configs/api.config'
import { ErrorNotice } from '@/modules/epilot-idp/shared'
import { useAuth } from '@/providers/AuthContextProvider'
import { useQueryGetOrganizations } from '@/services/organization.service'
import { isPermitted, Permissions } from '@/utils/permission-manager'

export const PHONE_PATH = '/phone'

export const phoneSetupPath = (orgId: string) =>
  `${PHONE_PATH}/${encodeURIComponent(orgId)}`

/** The organization's name from the (cached) organization list, once it has loaded. */
export const useOrganizationName = (orgId: string) => {
  const { data: organizations } = useQueryGetOrganizations()

  return organizations?.find((org) => org.id === orgId)?.name || undefined
}

export const PhoneAccess = () => {
  const { userData } = useAuth()

  // Guard the nested detail/create routes too, not only the sidebar item.
  if (!userData || !isPermitted(Permissions.MANAGE_PHONE, userData)) {
    return (
      <ErrorNotice message="Phone setup is available to admin and super-admin users." />
    )
  }
  if (!config.PHONE_INTEGRATION)
    return (
      <ErrorNotice message="Phone integration API is not configured for this stage." />
    )

  return <Outlet />
}
